import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FocusModeProvider } from './FocusModeContext';  // ✅ IMPORT CONTEXT PROVIDER

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FocusModeProvider>
      <App />
    </FocusModeProvider>
  </React.StrictMode>
);

reportWebVitals();
